import { Col } from '@/components/grid/grid-component';
import Input from '@/components/react-hook-form-inputs/input/input-component';
import PhoneInputComponent from '@/components/react-hook-form-inputs/input/phone-input/phone-input-component';
import RadioButton from '@/components/react-hook-form-inputs/radio-button/radio-button-component';
import SelectSearch from '@/components/react-hook-form-inputs/select-search/select-search-component';
import {
  cellphoneNumberRegex,
  emailRegex,
  requiredValidationMessage,
} from '@/utils/validations';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import Styled from './customer-form.style';

/**
 * Customer contact form
 * @param { boolean }edit - form type edit or create
 * @returns {JSX.Element}
 */
const CustomerContactForm = ({ isLoading: updateLoading, superiorOptions }) => {
  const [customerStatus] = useState('');
  const {
    formState: { isLoading: formLoading },
    watch,
    setValue,
  } = useFormContext();
  const nameRef = useRef();
  const isLoading = formLoading || updateLoading;
  const customerStatusInitialColor = watch('customer.status');
  const superior = watch('superior');

  return (
    <Styled.MainContainer>
      <Col xs={12}>
        <Input
          disabled={isLoading}
          label="Name"
          placeholder="Contact Person Name"
          name="name"
          registerOptions={{
            required: requiredValidationMessage,
            ref: nameRef,
          }}
        />
      </Col>
      <Col xs={12}>
        <Input
          disabled={isLoading}
          label="Email Address"
          placeholder="Contact Person Email"
          name="email"
          registerOptions={{
            validate: (value) => {
              let errorMessage = null;
              emailRegex.forEach((rule) => {
                if (!rule.pattern.test(value)) {
                  errorMessage = rule.message;
                }
              });
              return errorMessage || true;
            },
          }}
        />
      </Col>
      <Col xs={12}>
        <PhoneInputComponent
          name="contact_number"
          disabled={isLoading}
          registerOptions={{
            validate: (value) => {
              let errorMessage = null;
              cellphoneNumberRegex.forEach((rule) => {
                if (!rule.pattern.test(value)) {
                  errorMessage = rule.message;
                }
              });
              return errorMessage || true;
            },
          }}
        />
      </Col>
      <Col xs={12}>
        <Input
          disabled={isLoading}
          label="Position"
          placeholder="Company Position"
          name="position"
          registerOptions={{
            required: requiredValidationMessage,
          }}
        />
      </Col>
      <Col xs={12}>
        <SelectSearch
          cy="selContactPersonSuperior"
          header="Superior"
          name="superior"
          label="Please select a status"
          options={superiorOptions}
          icon={
            <Styled.StatusCircle
              status={customerStatusInitialColor || customerStatus}
            />
          }
          isLoading={isLoading}
          defaultValue={
            superior?.id ? { value: superior?.id, label: superior?.name } : {}
          }
        />
      </Col>
      <Col xs={12}>
        <RadioButton
          hideLabel
          options={[
            {
              value: true,
              label: 'Default recipient of quotes',
            },
          ]}
          name="default_recipient_of_quotes"
          registerOptions={{
            onChange: (v) => {
              if (v.target.value === 'true') {
                setValue(`default_recipient_of_quotes`, true);
              }
            },
          }}
        />
      </Col>
    </Styled.MainContainer>
  );
};

CustomerContactForm.defaultProps = {
  isLoading: false,
  superiorOptions: [],
};

CustomerContactForm.propTypes = {
  isLoading: PropTypes.bool,
  superiorOptions: PropTypes.array,
};

export default CustomerContactForm;
